const Coagadex = () => {
  return (
    <>
      <div className="mx-auto">
        <div className="mt-10 font-bold">PATIENT ELIGIBILITY GUIDELINES FOR COPAY ASSISTANCE</div>

        <ul className="list-disc ml-10">
          <li className="my-2">
            The Coagadex Copay Support Program is for patients who have a valid prescriptions for
            Coagadex regardless of financial need
          </li>
          <li className="my-2">Valid for out-patient prescriptions only</li>
          <li className="my-2">
            Not valid for prescriptions reimbursed by Medicaid, Medicare, VA, TRICARE, or any other
            federal or state healthcare programs
          </li>
          <li className="my-2">
            Not valid where prohibited by health insurance provider or by law*
          </li>
          <li className="my-2">
            Non-medication expenses, such as ancillary infusion supplies, are not eligible
          </li>
          <li className="my-2">
            BPL reserves the right to rescind, revoke, or change the program rules at any time, in
            whole, or in part at any time without notice
            <p className="mt-4 italic">
              * Prior to enrolling in this Kedrion Biopharma Inc. program, participants are
              responsible for checking with their insurance carrier to confirm that their
              participation is not inconsistent with their insurance carrier’s requirements.
            </p>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Coagadex;
